import dayjs from "dayjs";

import {
  TIME_LOOKBACK_RANGES_TO_DAYS_AGO,
  TimeLookbackRange,
} from "@shared/types";

export const calculateLookbackSeconds = (tlr: TimeLookbackRange) => {
  const daysAgo = TIME_LOOKBACK_RANGES_TO_DAYS_AGO[tlr];
  return daysAgo === Infinity ? 0 : dayjs().subtract(daysAgo, "days").unix();
};
